import { render, staticRenderFns } from "./pdfdetail.vue?vue&type=template&id=7e0c5925&scoped=true&"
import script from "./pdfdetail.vue?vue&type=script&lang=js&"
export * from "./pdfdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0c5925",
  null
  
)

export default component.exports